import styles from './Hotels.module.scss'
export const TitleRow = ({ handleClickTitle, sortParam }) => (
  <div className={styles.titleRow}>
    <div
      style={{ cursor: 'pointer' }}
      onClick={() => handleClickTitle('displayId')}
      className={styles.bookingEngine}
    >
      #id {sortParam === 'displayId' ? '▲' : ''}
    </div>
    <div
      style={{ cursor: 'pointer' }}
      onClick={() => handleClickTitle('chain')}
      className={styles.chainCode}
    >
      chain / parent code {sortParam === 'chain' ? '▲' : ''}
    </div>
    <div
      style={{ cursor: 'pointer' }}
      onClick={() => handleClickTitle('addedOn')}
      className={styles.addedOn}
    >
      added on {sortParam === 'addedOn' ? '▲' : ''}
    </div>
    <div
      style={{ cursor: 'pointer' }}
      onClick={() => handleClickTitle('updatedOn')}
      className={styles.lastUpdated}
    >
      updated on {sortParam === 'updatedOn' ? '▲' : ''}
    </div>
    <div
      style={{ cursor: 'pointer' }}
      onClick={() => handleClickTitle('city')}
      className={styles.lastUpdated}
    >
      city {sortParam === 'city' ? '▲' : ''}
    </div>
    <div
      style={{ cursor: 'pointer' }}
      onClick={() => handleClickTitle('state')}
      className={styles.lastUpdated}
    >
      state {sortParam === 'state' ? '▲' : ''}
    </div>
    <div className={styles.ctaCol}></div>
  </div>
)
